import { etiquetaRelacionador } from '../../../utils/identidadOperativa';
// src/pages/reservas/components/WizardReserva.jsx
import React from 'react';

export default function WizardReserva({
  open,
  zonaActiva,
  paso,
  tituloZona,
  pisoZona,
  tipoZonaTexto,
  error,
  form,
  setForm,
  esOwnerOSocio,
  listaReservadores,
  nombreUsuario,
  loadingPaquetes,
  generandoEntrega,
  onClose,
  onBack,
  onNext,
  onNoPrepago,
  onSiPrepago,
}) {
  if (!open || !zonaActiva) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="wizard-top">
          <div className="wizard-chip">Paso {paso} de 3</div>
          <div className="wizard-title">{tituloZona}</div>
          <div className="wizard-sub">{pisoZona}</div>
        </div>

        {error && <div className="wizard-error">{error}</div>}

        {/* PASO 1 */}
        {paso === 1 && (
          <>
            <p className="wizard-question">¿Desea reservar esta {tipoZonaTexto(zonaActiva)}?</p>

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancelar
              </button>

              <button
                type="button"
                className="btn-primary"
                onClick={onNext}
                disabled={loadingPaquetes}
                title={loadingPaquetes ? 'Cargando paquetes…' : ''}
              >
                Sí, reservar
              </button>
            </div>
          </>
        )}

        {/* PASO 2 */}
        {paso === 2 && (
          <>
            <p className="wizard-question">¿A nombre de quién es la reserva?</p>

            <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
              <label>
                Nombre y apellido
                <input
                  type="text"
                  value={form.nombreCliente}
                  onChange={(e) => setForm((f) => ({ ...f, nombreCliente: e.target.value }))}
                  placeholder="Ej: Juan Pérez"
                  autoFocus
                />
                <span className="wizard-hint">1 nombre y 1 apellido.</span>
              </label>

              {esOwnerOSocio && (
                <label>
                  Asignar reserva a (RRPP / Imagen)
                  <select
                    value={form.atribuidoAUid}
                    onChange={(e) => {
                      const id = e.target.value;
                      const elegido = (listaReservadores || []).find((p) => p.id === id);
                      setForm((f) => ({
                        ...f,
                        atribuidoAUid: id,
                        atribuidoANombre: elegido ? elegido.nombre : '',
                      }));
                    }}
                  >
                    <option value="">Sin atribución (operación propia)</option>
                    {(listaReservadores || []).map((p) => (
                      <option key={p.id} value={p.id}>
                        {etiquetaRelacionador(p)}
                      </option>
                    ))}
                  </select>

                  <span className="wizard-hint">
                    Opcional: selecciona un RRPP o Imagen activo autorizado para este evento.
                  </span>
                </label>
              )}

              {!esOwnerOSocio && (
                <div className="wizard-info">
                  Reservando como: <b>{nombreUsuario || 'Usuario'}</b>
                </div>
              )}
            </form>

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onBack}>
                Atrás
              </button>
              <button type="button" className="btn-primary" onClick={onNext}>
                Continuar
              </button>
            </div>
          </>
        )}

        {/* PASO 3 (SIN Atrás / Continuar) */}
        {paso === 3 && (
          <>
            <p className="wizard-question">¿Quiere prepagar la reserva?</p>

            <div className="wizard-yesno">
              <button
                type="button"
                className="wizard-pill"
                onClick={onNoPrepago}
                disabled={generandoEntrega}
              >
                No (queda Reservada)
              </button>

              <button
                type="button"
                className="wizard-pill"
                onClick={onSiPrepago}
                disabled={generandoEntrega}
              >
                Sí (prepagar)
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
